<template>
  <div class="carousel-navigation">
    <button
      v-if="autoplay"
      :aria-label="play ? labels.navigation.ariaLabelPause : labels.navigation.ariaLabelPlay"
      :class="['carousel-navigation-button', { 'carousel-navigation-play' : !play }, { 'carousel-navigation-pause' : play }]"
      @click.prevent="$emit('toggleAutoPlay'), play = !play"
      v-tag:useractionevent="{'name':'sticky_nav_slider_click','click_action':'next' }"
      >
      <div class="icon"/>
    </button>
    <button
      v-if="showNavigation"
      :aria-label="labels.navigation.ariaLabelPrev"
      class="carousel-navigation-button carousel-navigation-prev"
      @click.prevent="$emit('changeSlide', 'backward')"  v-tag:useractionevent="{'name':'sticky_nav_slider_click','click_action':'previous' }">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="29" viewBox="0 0 18 29" aria-hidden="true">
        <path fill="#000" fill-rule="evenodd" d="M15.77 28.68a1.435 1.435 0 0 0 1.842-.03c.505-.453.519-1.185.032-1.655L3.501 14.277 17.644 2.005A1.108 1.108 0 0 0 17.612.35 1.435 1.435 0 0 0 15.77.32L0 14.277 15.77 28.68z"/>
      </svg>
    </button>
    <button
      v-if="showNavigation"
      :aria-label="labels.navigation.ariaLabelNext"
      class="carousel-navigation-button carousel-navigation-next"
      @click.prevent="$emit('changeSlide', 'forward')"  v-tag:useractionevent="{'name':'sticky_nav_slider_click','click_action':'next' }">
      <svg class="carousel-icon--reverse" xmlns="http://www.w3.org/2000/svg" width="18" height="29" viewBox="0 0 18 29" aria-hidden="true">
        <path fill="#000" fill-rule="evenodd" d="M15.77 28.68a1.435 1.435 0 0 0 1.842-.03c.505-.453.519-1.185.032-1.655L3.501 14.277 17.644 2.005A1.108 1.108 0 0 0 17.612.35 1.435 1.435 0 0 0 15.77.32L0 14.277 15.77 28.68z"/>
      </svg>
    </button>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler';

  export default {
    name: 'navigation',
    directives: {
      tag
    },
    props: {
      labels: { type: Object, required: true },
      autoplay: { type: Boolean, required: false, default: false },
      showNavigation: { type: Boolean, required: false, default: false }
    },
    data() {
      return {
        play: true
      };
    },
  };
</script>
